export var getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
  var invalidLabel = _ref.invalidLabel,
    emptyLabel = _ref.emptyLabel,
    labelFunc = _ref.labelFunc;
  var date = utils.date(value);
  if (labelFunc) {
    return labelFunc(isEmpty ? null : date, invalidLabel);
  }
  if (isEmpty) {
    return emptyLabel || '';
  }
  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};
var getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }
  return utils.endOfDay(date);
};
var getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }
  return utils.startOfDay(date);
};
export var validate = function validate(value, utils, _ref2) {
  var maxDate = _ref2.maxDate,
    minDate = _ref2.minDate,
    disablePast = _ref2.disablePast,
    disableFuture = _ref2.disableFuture,
    maxDateMessage = _ref2.maxDateMessage,
    minDateMessage = _ref2.minDateMessage,
    invalidDateMessage = _ref2.invalidDateMessage,
    strictCompareDates = _ref2.strictCompareDates;
  var parsedValue = utils.date(value); // if null - do not show error

  if (value === null) {
    return '';
  }
  if (!utils.isValid(value)) {
    return invalidDateMessage;
  }
  if (maxDate && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) {
    return maxDateMessage;
  }
  if (disableFuture && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) {
    return maxDateMessage;
  }
  if (minDate && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) {
    return minDateMessage;
  }
  if (disablePast && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) {
    return minDateMessage;
  }
  return '';
};
export function pick12hOr24hFormat(userFormat) {
  var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var formats = arguments.length > 2 ? arguments[2] : undefined;
  if (userFormat) {
    return userFormat;
  }
  return ampm ? formats['12h'] : formats['24h'];
}
export function makeMaskFromFormat(format, numberMaskChar) {
  return format.replace(/[a-z]/gi, numberMaskChar);
}
export var maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
  return function (value) {
    if (value === '') {
      return value;
    }
    var result = '';
    var parsed = value.replace(refuse, '');
    var i = 0;
    var n = 0;
    while (i < mask.length) {
      var maskChar = mask[i];
      if (maskChar === numberMaskChar && n < parsed.length) {
        var parsedChar = parsed[n];
        result += parsedChar;
        n += 1;
      } else {
        result += maskChar;
      }
      i += 1;
    }
    return result;
  };
};